import { render, staticRenderFns } from "./signboard.vue?vue&type=template&id=02a88c49&scoped=true&"
import script from "./signboard.vue?vue&type=script&lang=js&"
export * from "./signboard.vue?vue&type=script&lang=js&"
import style0 from "./signboard.vue?vue&type=style&index=0&id=02a88c49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a88c49",
  null
  
)

export default component.exports